import React from 'react';
import { InternalErrorPage } from '@pages/InternalError/InternalErrorPage';
import { Outlet } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';

export const ErrorBoundaryLayout = () => (
  <ErrorBoundary fallback={<InternalErrorPage />}>
    <Outlet />
  </ErrorBoundary>
);
